var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel_shouyin"},[_c('el-button',{on:{"click":_vm.getData}},[_vm._v("发送")]),_c('el-button',{on:{"click":_vm.getList}},[_vm._v("获取列表")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }